module.exports = __webpack_public_path__ + "1adbcddd47ee033aeab8f498a2208932.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/mini-snowman.png
// module id = 3024
// module chunks = 0